(function(){'use strict';
// Keep each personalization property once. Upload controls with different keys stay active.
function scrub(){
 document.querySelectorAll('.jw-product-form form').forEach(function(form){
  var roots=Array.from(form.querySelectorAll('.jw-perso'));
  var names=new Set();roots.forEach(function(root){root.querySelectorAll('[name^="properties["]').forEach(function(input){names.add(input.name);});});
  if(!names.size)return;
  form.querySelectorAll('#infiniteoptions-container input,#infiniteoptions-container select,#infiniteoptions-container textarea').forEach(function(input){
   if(!names.has(input.name))return;
   input.disabled=true;input.hidden=true;
   var parent=input.closest('#infiniteoptions-container > div');
   if(parent&&!Array.from(parent.querySelectorAll('input,select,textarea')).some(function(other){return other.type!=='hidden'&&!names.has(other.name);}))parent.hidden=true;
  });
  var container=form.querySelector('#infiniteoptions-container');
  if(container&&!Array.from(container.querySelectorAll('input,select,textarea')).some(function(input){return !input.disabled&&input.type!=='hidden';}))container.hidden=true;
 });
}
function start(){scrub();var scheduled=false;new MutationObserver(function(records){
 if(scheduled)return;
 var relevant=records.some(function(record){return (record.target instanceof Element&&record.target.closest('#infiniteoptions-container'))||Array.from(record.addedNodes).some(function(node){return node instanceof Element&&(node.matches('#infiniteoptions-container')||node.querySelector('#infiniteoptions-container'));});});
 if(!relevant)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;scrub();});
}).observe(document.body,{childList:true,subtree:true});
// Native mobile menus retain ordinary browser focus and keyboard behavior.
var header=document.querySelector('.jw-header');if(header)header.querySelectorAll('details').forEach(function(details){details.addEventListener('toggle',function(){if(details.open)header.querySelectorAll('details').forEach(function(other){if(other!==details)other.open=false;});});});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
